var map = {
	"./bandle city-splashvideo.webm": 1859,
	"./bilgewater-splashvideo.webm": 4876,
	"./demacia-splashvideo.webm": 2599,
	"./freljord-splashvideo.webm": 9760,
	"./ionia-splashvideo.webm": 5980,
	"./ixtal-splashvideo.webm": 7236,
	"./noxus-splashvideo.webm": 5747,
	"./piltover-splashvideo.webm": 5043,
	"./shadow isles-splashvideo.webm": 5026,
	"./shurima-splashvideo.webm": 2954,
	"./targon-splashvideo.webm": 7161,
	"./the void-splashvideo.webm": 9145,
	"./zaun-splashvideo.webm": 8913
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8500;